import React from "react";

export default function OrganizationListItem({item}) {
    const MemoImage = React.memo(function Image({src, alt}) {
        return (
            <img src={src} alt={alt}/>
        );
    });
    return (
        <a href={"/organization/" + item.urlSlug} className="organization-item flex">
            <div className="img-block flex-center">
                <MemoImage src={item.image} alt={'no-image'}/>
            </div>
            <div className="info">
                <h6>{item.name}</h6>
                <div className="feedback">
                    {
                        Object.keys(item.phones).map((key) => {
                            const tel = item.phones[key].replace(/(\d{3})(\d{2})(\d{3})(\d{2})(\d{2})/, "$1 ($2) $3-$4-$5");

                            return (<span key={tel}>{tel}</span>);
                        })
                    }
                    {
                        Object.keys(item.emails).map((key) => {
                            return (<span key={item.emails[key]}>{item.emails[key]}</span>);
                        })
                    }
                    <span className="website">
                        {
                            Object.keys(item.websites).map((key) => {
                                const website = item.websites[key].replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split('/')[0];

                                return (<span key={website} className="js-website" data-url="' + websites[key] + '">{website}</span>);
                            })
                        }
                    </span>
                </div>
                <div className="address">
                    {
                        Object.keys(item.addresses).map((key) => {
                            return (<p key={item.addresses[key]}>{item.addresses[key]}</p>);
                        })
                    }
                </div>
            </div>
        </a>
    );
}
